import {
  Component, EventEmitter, HostBinding, Input, OnChanges, Output, SimpleChanges,
} from '@angular/core';
import { AbstractFilterElementComponent, FilterEmitterType } from './abstract-filter-element.component';
import { FilterElementSize, gridClassesForFilterElementSize } from './filter-elements';

@Component({
  selector: 'boolean-filter-element',
  templateUrl: './boolean-filter-element.component.html',
})
export class BooleanFilterElementComponent extends AbstractFilterElementComponent implements OnChanges {
  @HostBinding('class')
  override componentClass = '';

  @Input()
  override size: FilterElementSize = FilterElementSize.SMALL;

  @Input()
  override label: string | undefined;

  @Input()
  override filterActive = false;

  @Input()
  override filterKey!: string;

  @Output()
  override filterTerm: EventEmitter<FilterEmitterType> = new EventEmitter();

  ngOnChanges(changes: SimpleChanges) {
    if (changes['size']) {
      this.componentClass = gridClassesForFilterElementSize(changes['size'].currentValue);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
  override onFilterChange(changes: unknown) {}
}
